export enum StackContainerDirection {
  Row = "Row",
  Column = "Column",
}
